import React from 'react';

export type EchoMood = 'hello' | 'celebrate' | 'thinking' | 'sleeping' | 'sad';

/** Echo, LingoPing's bat mascot (artwork copied from the extension's public/brand). */
export const Echo: React.FC<{ mood: EchoMood; size?: number; alt?: string }> = ({
  mood,
  size = 96,
  alt = '',
}) => (
  <img
    src={`/brand/echo-${mood}.svg`}
    alt={alt}
    aria-hidden={alt ? undefined : true}
    width={size}
    height={size}
    draggable={false}
    style={{ display: 'block', flexShrink: 0 }}
  />
);

/** The indigo app icon, used as the logo in the sidebar. */
export const EchoLogo: React.FC<{ size?: number }> = ({ size = 32 }) => (
  <img
    src="/brand/echo-icon.svg"
    alt=""
    aria-hidden
    width={size}
    height={size}
    draggable={false}
    style={{ display: 'block', flexShrink: 0, borderRadius: size * 0.23 }}
  />
);
